<div class="container-fluid" style="margin-bottom: 70%;" >
    <div class="row align-items-center justify-content-center">
        <div class="col-12 text-white text-center">
            <div class="container">
                <div class="row align-items-center justify-content-center">
                    <div class="col-12 text-center">
                        <h5 class="p-0" style="font-weight: 400; margin-top: 30%;">Estructuramos tus ideas en proyectos de software para hacerlas realidad.</h5>
                        <p style="font-weight: 400; font-size: 10px;">Si lo imaginaste, podemos programarlo.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-lottie
    id="animation"
    [options]="options" 
    (animationCreated)="animationCreated($event)" 
    width="700px"
    style="position: absolute; top: 22%; z-index: 1030; right: 0;" 
></ng-lottie>

